<template>
  <FormControl :required="required" :label="label" :indent="indent" @disabled="onSetDisabled">
    <select
      ref="select"
      slot-scope="slotProps"
      @change="onChange"
      v-model="model[name]"
      class="form-control"
      :class="{'load-spinner': options === null, 'is-invalid': slotProps.hasError}"
      :multiple="multi ? 'multiple' : null"
      tabindex="0"
      :disabled="getIsDisabled()"
    >
      <option
        v-if="!multi"
        value
        :disabled="!allowsNull"
      >{{ textWhenNull ? textWhenNull : i18n.app.select.choose_an_option }}</option>
      <option
        v-for="option in options"
        v-bind:key="option.value"
        :value="option.value"
      >{{ option.text }}</option>
    </select>
  </FormControl>
</template>

<script>
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";

export default {
  props: [
    "label",
    "indent",
    "required",
    "model",
    "name",
    "options",
    "textWhenNull",
    "multi",
    "disabled",
    "allowsNull"
  ],
  components: {
    FormControl
  },
  mounted() {
    if (!this.model[this.name]) this.model[this.name] = this.multi ? [] : "";

    if (this.multi) {
      this.initMultiSelect();
    }

    this.$forceUpdate();
  },
  methods: {
    initMultiSelect() {
      $(this.$refs.select).multiselect({
        onChange: (option, checked) => {
          const val = option[0].value;
          const index = this.model[this.name].findIndex(
            item => item == val || item == Number(val)
          );
          const exists = index > -1;

          if (checked && !exists) {
            this.model[this.name].push(val);
            this.onSelect(val);
          } else if (!checked && exists) {
            this.model[this.name].splice(index, 1);
            this.onDeselect(val);
          }
        }
      });
    },
    onSelect(val) {
      this.$emit("select", val);
    },
    onDeselect(val) {
      this.$emit("deselect", val);
    }
  },
  mixins: [formControlMixin]
};
</script>
